import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';

import { Spin } from 'antd';

import { logoutUser } from '@/shared/helpers';

export const LogoutProvider = ({ children }: PropsWithChildren) => {
  const shouldLogout = window.location.pathname.includes('logout');

  useEffect(() => {
    if (shouldLogout) {
      logoutUser();
    }
  }, [shouldLogout]);

  if (!shouldLogout) {
    return children;
  }

  return (
    <Spin
      fullscreen
      size="large"
    />
  );
};
